import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { MultiSwitch } from '../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import QuickTradeModule from '../../quickTradeModule/QuickTradeModule';
import { MiniOrdersTable } from './miniOrdersTable/MiniOrdersTable';
import style from './OrdersAndQuickTradeContainer.module.css';

export const OrdersAndQuickTradeContainer = ({ tradePlanId }) => {
  const [selection, setSelection] = useState('quickTrade');

  return (
    <div className={style.container}>
      <div className={style.topControls}>
        <MultiSwitch
          margin="0 0 5px 0"
          labels={['Quick Trade', 'Orders']}
          values={['quickTrade', 'orders']}
          setValue={setSelection}
          controlledValue={selection}
        />
      </div>

      {selection === 'quickTrade' ? (
        <QuickTradeModule tradePlanId={tradePlanId} />
      ) : <MiniOrdersTable tradePlanId={tradePlanId} />}
    </div>
  );
};

OrdersAndQuickTradeContainer.propTypes = {
  tradePlanId: PropTypes.any
};
